import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { bootstrapAuth } from "./utils/auth";
import AdminSubscriptionPage from "./pages/AdminUser";
import AdminDashboard from "./pages/AdminDashboard";
import LocationImagesPage from "./pages/LocationImagesPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import SubscribePage from "./pages/SubscribePage";
import UploadImagePage from "./pages/UploadImagePage";
import UploadsPage from "./pages/UploadsPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import UserDetails from "./pages/UserDetails";
import DownloadPage from "./pages/DownloadPage";
import PricingPage from "./pages/PricingPage";
import BillingPage from "./pages/BillingPage";
import BillingSuccess from "./pages/BillingSuccess";
import BillingCancel from "./pages/BillingCancel";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import Footer from "./components/Footer";

function App() {
  // Restore the session from the HttpOnly refresh cookie (or migrate a legacy
  // localStorage session) before rendering routes, so the in-memory access token
  // is populated before any page reads it. Public pages don't need auth, but the
  // one-time bootstrap is cheap and avoids a redirect flash on protected pages.
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    bootstrapAuth().finally(() => {
      if (active) setReady(true);
    });
    return () => {
      active = false;
    };
  }, []);

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0b0f]">
        <div className="text-zinc-500">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
    <div className="flex-1">
    <Routes>
      <Route
        path="/login"
        element={<LoginPage />}
      />
      <Route
        path="/register"
        element={<RegisterPage />}
      />
      <Route
        path="/uploads"
        element={<UploadsPage />}
      />
      <Route
        path="/upload-image"
        element={<UploadImagePage />}
      />
      <Route
        path="/location-images"
        element={<LocationImagesPage />}
      />
      <Route
        path="/subscribe"
        element={<SubscribePage />}
      />
      <Route
        path="/pricing"
        element={<PricingPage />}
      />
      <Route
        path="/billing"
        element={<BillingPage />}
      />
      <Route
        path="/billing/success"
        element={<BillingSuccess />}
      />
      <Route
        path="/billing/cancel"
        element={<BillingCancel />}
      />
      <Route
        path="/admin-update-user-subscription"
        element={<AdminSubscriptionPage />}
      />
      <Route
        path="/admin"
        element={<AdminDashboard />}
      />
      <Route
        path="/admin/user/:email"
        element={<UserDetails />}
      />
      <Route
        path="/forgot-password"
        element={<ForgotPasswordPage />}
      />
      <Route
        path="/reset-password"
        element={<ResetPasswordPage />}
      />
      <Route
        path="/change-password"
        element={<ChangePasswordPage />}
      />
      <Route
        path="/download"
        element={<DownloadPage />}
      />
      <Route
        path="/privacy"
        element={<PrivacyPolicyPage />}
      />
      <Route
        path="/"
        element={<LoginPage />}
      />
    </Routes>
    </div>
    <Footer />
    </div>
  );
}

export default App;
